<template>
  <div>
    <div
      v-if="emptyOutput"
      class="-mx-2 rounded-lg border-2 border-dashed px-2 py-2 text-gray-400 hover:border-gray-400 hover:text-gray-500"
    >
      <slot />
    </div>
    <div v-else class="prose leading-relaxed prose-hr:my-6 sm:max-w-none" v-html="output"></div>
  </div>
</template>

<script>
import { generateHTML } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { Link } from '@tiptap/extension-link'
import { Placeholder } from '../classes/Placeholder.ts'

export default {
  props: {
    content: Object,
    highlightPlaceholders: Boolean,
  },
  computed: {
    output() {
      if (!this.content || Object.keys(this.content).length === 0) {
        return ''
      }

      return generateHTML(this.content, [
        StarterKit,
        Link,
        Placeholder.configure({
          highlightEmpty: this.highlightPlaceholders,
        }),
      ])
    },
    emptyOutput() {
      return !this.output || this.output === '<p></p>'
    },
  },
}
</script>
